module.exports = __webpack_public_path__ + "static/media/mitsl200-1986mh.d18de02f.webp";